import {ID} from '~/lib/model';

export const pmpLinks = {
    pmp: () => '/pmp',
    supplyPackages: () => `/pmp/supply-packages`,
    supplyPackage: (supplyPackageId: ID) =>  `/pmp/supply-packages/${supplyPackageId}`,
    deals: () => `/pmp/deals`,
    sensitiveCategories: () => '/pmp/sensitive-categories',
};
